// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.waiting_waiting__fFzUf {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/pages/fill-information/components/waiting/waiting.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACF","sourcesContent":[".waiting {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"waiting": `waiting_waiting__fFzUf`
};
export default ___CSS_LOADER_EXPORT___;
